export const EN_US = 'en-US';
export const EN_UK = 'en-UK';
export const FR_FR = 'fr-FR';
export const ES_SP = 'es-SP';
